module.exports = __webpack_public_path__ + "img/1526049511.db9928fe.jpg";